import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-138">
            <img src="https://cdn.magicpatterns.com/uploads/w5xbAyEgQZsmGo1CTJQaAo/Split_image,_before_and_after_202605111438.jpg" alt="Contraste entre insomnio y descanso" className="w-full h-auto rounded-xl shadow-2xl border border-[#15203B]" width="1024" height="1024" loading="lazy" decoding="async" data-id="element-139" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2 space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-140">
            <h2 className="font-serif text-3xl md:text-4xl text-white font-bold leading-tight mb-6" data-id="element-141">
              Cuando todo se queda en silencio… el ruido parece hacerse más
              fuerte
            </h2>

            <div className="space-y-2" data-id="element-142">
              <p data-id="element-143">Puede que durante el día lo ignores.</p>
              <p data-id="element-144">Pero llega la noche.</p>
              <p data-id="element-145">Apagas la luz.</p>
              <p data-id="element-146">Te acuestas.</p>
              <p data-id="element-147">Intentas relajarte.</p>
              <p data-id="element-148">Y entonces aparece.</p>
              <p data-id="element-149">Ese pitido.</p>
              <p data-id="element-150">Ese zumbido.</p>
              <p data-id="element-151">Esa presión invisible que nadie más escucha.</p>
              <p data-id="element-152">
                Y mientras más intentas no pensarlo… más presente se vuelve.
              </p>
            </div>

            <div className="bg-[#15203B] p-6 rounded-lg border-l-4 border-[#F6C65B] mt-8 shadow-lg" data-id="element-153">
              <p className="text-white font-medium" data-id="element-154">
                No estás imaginándolo. Lo que ocurre es que tu cerebro puede
                entrar en un estado de vigilancia auditiva, donde empieza a
                buscar, medir y amplificar ese sonido interno. Y cuando eso
                sucede por la noche, dormir se vuelve difícil.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}